import { useEffect, useMemo } from 'react';
import styles from './styles.module.scss';
import Button from '@components/common/button';
import Typography from '@components/common/typography';
import { useNavigate } from 'react-router-dom';
import { routes } from '@const/routes';
import { useUserContext } from '@hooks/context/useUserContext';
import BankSection from '@sections/manage_accounts/bank';
import { motion } from 'framer-motion';
import { pageAnimation } from '@const/animation';
import { useQueryParams } from '@hooks/helpers/useQueryParams';
import { useManageAccountModals } from '@hooks/modals/useManageAccountModals';
// TEMP-HIDE EPS (founder 2026-06-29) — restore to re-enable
// import CardSection from '@sections/manage_accounts/card';
import { Icon } from '@components/icons';
import classNames from 'classnames/bind';
import WalletSection from '@sections/manage_accounts/wallet';
import useResponsive from '@hooks/helpers/useResponsive';
import { prettifyStars } from '@utils/index';
import { useLocales } from '@hooks/helpers/useLocales';

const cx = classNames.bind(styles);

const ManageAccountsLayout = () => {
    // const { t } = useTranslation('manage_accounts');
    const [id] = useQueryParams(['id']);
    const navigate = useNavigate();
    const { account } = useUserContext();
    const { isMobile } = useResponsive();
    const { submitLocale } = useLocales();

    const chosenAccount = useMemo(() => {
        return account?.bank_accounts?.find((item) => item.id === id);
    }, [id, account]);

    // TEMP-HIDE EPS (founder 2026-06-29) — restore to re-enable
    // const chosenCard = useMemo(() => {
    //     return account?.eps_cards?.find((item) => item.id === id);
    // }, [id, account]);
    const chosenCard = undefined;

    const { removeBankAccount /*, removeEPSCard*/ } = useManageAccountModals({
        // TEMP-HIDE EPS (founder 2026-06-29) — restore to re-enable: pass chosenCard
        id,
        chosenAccount,
        chosenCard
    });

    useEffect(() => {
        if (chosenAccount) {
            navigate(`${routes.manage_accounts}?id=${chosenAccount.id}`);
        }
    // TEMP-HIDE EPS (founder 2026-06-29) — restore to re-enable: add chosenCard back to deps
    }, [chosenAccount]);

    return (
        <motion.div {...pageAnimation} className={styles.wrapper}>
            <div className={styles.left}>
                <div className={styles.content}>
                    <div className={styles.actions_wrapper}>
                        {/* TEMP-HIDE EPS (founder 2026-06-29) — restore to re-enable
                        <div
                            className={styles.action}
                            onClick={() => navigate(`${routes.link_card_bank}?type=card`)}>
                            <Button
                                iconSize={32}
                                variant="icon-dark"
                                size="large"
                                leftIcon="link_card"
                            />
                            <Typography variant="button_medium">Link a card</Typography>
                        </div>
                        */}
                        <div
                            className={styles.action}
                            onClick={() => navigate(`${routes.link_card_bank}?type=bank`)}>
                            <Button
                                iconSize={32}
                                variant="icon-dark"
                                size="large"
                                leftIcon="link_bank"
                            />
                            <Typography variant="button_medium">Link a bank account</Typography>
                        </div>
                    </div>
                    <div
                        className={cx(styles.item, { isChecked: 'wallet' === id })}
                        onClick={() => navigate(`${routes.manage_accounts}?id=wallet`)}>
                        <div className={styles.data}>
                            <Icon name="filled_wallet" />
                            <div className={styles.text_wrapper}>
                                <Typography className={styles.title}>XEPPT wallet</Typography>
                                <Typography className={styles.description}>
                                    ${account?.balance.toFixed(2)} available
                                </Typography>
                            </div>
                        </div>
                    </div>
                    {account?.bank_accounts?.map((item) => {
                        return (
                            <div
                                className={cx(styles.item, { isChecked: item.id === id })}
                                key={item.id}
                                onClick={() => navigate(`${routes.manage_accounts}?id=${item.id}`)}>
                                <div className={styles.data}>
                                    <Icon name="filled_bank" />
                                    <div className={styles.text_wrapper}>
                                        <Typography className={styles.title}>
                                            {item.institution_name}
                                        </Typography>
                                        <Typography className={styles.description}>
                                            {item.account_name} {prettifyStars(item.account_number)}
                                        </Typography>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                    {/*TEMP-HIDE EPS (founder 2026-06-29) — restore to re-enable*/}
                    {/*{account?.eps_cards?.map((item) => {
                        return (
                            <div
                                className={cx(styles.item, { isChecked: item.id === id })}
                                key={item.id}
                                onClick={() => navigate(`${routes.manage_accounts}?id=${item.id}`)}>
                                <div className={styles.data}>
                                    <Icon name="filled_card" />
                                    <div className={styles.text_wrapper}>
                                        <Typography className={styles.title}>
                                            {item.card_holder_name} ({item.card_brand})
                                        </Typography>
                                        <Typography className={styles.description}>
                                            {prettifyCardStars(item.card_number)}
                                        </Typography>
                                    </div>
                                </div>
                            </div>
                        );
                    })}*/}
                </div>
            </div>
            <div
                className={cx(styles.right, {
                    // TEMP-HIDE EPS (founder 2026-06-29) — restore to re-enable: add `|| chosenCard`
                    isShown: !isMobile || (isMobile && (id === 'wallet' || chosenAccount))
                })}>
                {/* TEMP-HIDE EPS (founder 2026-06-29) — restore to re-enable: add `|| chosenCard` */}
                {(id === 'wallet' || chosenAccount) && (
                    <Button
                        className={styles.back}
                        leftIcon="arrow_left"
                        onClick={() => navigate(routes.manage_accounts)}>
                        {submitLocale('back')}
                    </Button>
                )}
                {chosenAccount && <BankSection account={chosenAccount} />}
                {/* TEMP-HIDE EPS (founder 2026-06-29) — restore to re-enable */}
                {/* {chosenCard && <CardSection card={chosenCard} />} */}
                {id === 'wallet' && <WalletSection />}
                {/* TEMP-HIDE EPS (founder 2026-06-29) — restore to re-enable: add `|| chosenCard` and the else branch */}
                {id !== 'wallet' && chosenAccount && (
                    <div className={styles.actions}>
                        <Button
                            className={styles.action}
                            variant="text-dark"
                            leftIcon="trash"
                            onClick={() => {
                                removeBankAccount();
                            }}>
                            <Typography>{submitLocale('remove')}</Typography>
                        </Button>
                    </div>
                )}
            </div>
        </motion.div>
    );
};

export default ManageAccountsLayout;
